import React, {useState} from 'react'
import {Button, Form, Grid, Header, Image, Dimmer, Loader, Segment} from 'semantic-ui-react'
import img from '../../../images/logo.png'
import  users from "../../../config/users";
import objDefault from '../../../models/usersModel'
import {reactLocalStorage} from 'reactjs-localstorage';
const LoginForm = () => {
    const [input, setInput] = useState({
        ...objDefault
    });
    const [user, setUser] = useState({});
    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;
        console.log(name, value, e)
        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }))
    };


    const userLogin = () =>{
        let findUserById = users[input.username]
        if(findUserById){
            if(input.password.trim() == findUserById.password){
                setInput((prevInput) => ({
                    ...prevInput,
                    userToken : input.username
                }))
                reactLocalStorage.set('token', findUserById);
                reactLocalStorage.set('name', findUserById.name+' ('+findUserById.code+')');
                reactLocalStorage.set('username', findUserById.name);
                window.open('/home','_self');
            }else {
                alert('รหัสผ่านผิดพลาด')
            }
        }else{
            alert('ไม่พบข้อมูล username หรือ password กรุณาติดต่อ admin')
        }

    }
    return (
        <Grid textAlign='center' style={{height: '100vh'}} verticalAlign='middle'>
            <Grid.Column style={{maxWidth: 450}}>
                <Header as='h2' color='teal' textAlign='center'>
                    <Image src={img}/> Log-in to your account
                </Header>
                <Form size='large'>
                    <Segment stacked>
                        <Form.Input fluid icon='user' name='username' iconPosition='left'  value={input.username} placeholder='username'  onChange={(e)=>handleValueChange(e)}/>
                        <Form.Input
                            fluid
                            icon='lock'
                            iconPosition='left'
                            name='password'
                            value={input.password}
                            onChange={(e)=>handleValueChange(e)}
                            placeholder='Password'
                            type='password'
                        />
                        {input.userToken ?  <Dimmer active inverted >+<Loader size='medium' >Loading</Loader>+</Dimmer> : ''}

                        <Button color='teal' fluid size='large'   onClick={(e) => userLogin()}>
                            Login
                        </Button>
                    </Segment>
                </Form>

            </Grid.Column>
        </Grid>
    )
}

export default LoginForm
